import { Component, Input } from '@angular/core';
import { EventPricingMatrix } from '../../../../../../../../models/event-type';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventTypeService } from '../../../../../../../../services/event-type/event-type.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../utils';

@Component({
  selector: 'app-remove-event-type-pricing-matrix-modal',
  templateUrl: './remove-event-type-pricing-matrix-modal.component.html',
  styleUrls: ['./remove-event-type-pricing-matrix-modal.component.css']
})
export class RemoveEventTypePricingMatrixModalComponent {
  @Input() matrix: EventPricingMatrix;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingRemove = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private eventTypeService: EventTypeService
  ) {}

  public handleSubmit() {
    this.loadingRemove = true;

    this.errorMessage = '';
    this.errors = {};

    this.eventTypeService.removeEventPricingMatrix(this.matrix)
      .then(() => {
        this.savedCallback({
          text: this.matrix.name + ' removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove pricing matrices.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRemove = false; });
  }
}
